var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoShare = function SvgVideoShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1a.75.75 0 0 1 .545.235l4.25 4.5a.75.75 0 0 1-1.09 1.03L12.75 3.636v9.614a.75.75 0 0 1-1.5 0V3.636L8.295 6.765a.75.75 0 1 1-1.09-1.03l4.25-4.5A.75.75 0 0 1 12 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 10.75C4 9.784 4.784 9 5.75 9h4v4.25a2.25 2.25 0 0 0 4.5 0V9h4c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 18.25 21H5.75A1.75 1.75 0 0 1 4 19.25z"
  })));
};
export default SvgVideoShare;